import styles from './identifier.module.scss';
import {classNames} from '../../support/classnames.ts';
import React, {CSSProperties} from 'react';
import {getLicensePlateCountry} from '../../support/license_plates/license_plate_country.ts';
import {formatLicensePlate} from '../../support/license_plates/license_plate_formatter.ts';
import {IdentifierSize} from '../../support/enums/identifier_size.ts';
import {IdentifierCountry} from '../../support/enums/identifier_country.ts';

interface OwnProps {
    identifier: string;
    size?: IdentifierSize;
    identifierCountry?: IdentifierCountry;
    style?: CSSProperties;
    children?: React.ReactNode;
}

export function Identifier({identifier, size, identifierCountry, style, children}: OwnProps) {
    const country = identifierCountry !== undefined ? identifierCountry : getLicensePlateCountry(identifier);
    return (
        <div
            style={style}
            className={classNames(styles.identifier, {
                [styles.large]: size === IdentifierSize.Large,
                [styles.nl]: country === IdentifierCountry.NL,
                [styles.de]: country === IdentifierCountry.DE,
                [styles.be]: country === IdentifierCountry.B,
            })}
        >
            <div className={styles.identifier__country}>
                <span>{country}</span>
            </div>

            {children ? <>{children}</> : <>{formatLicensePlate(identifier)}</>}
        </div>
    );
}
